































import { Component, Vue } from 'vue-property-decorator';
import { Action, Getter, Mutation } from 'vuex-class';
import { StoreNamespace } from '@/globals/StoreNamespaceGlobal';
import {
  FORM101_DATA,
  OPEN_FORM_STATUS_HISTORY_DIALOG,
  SET_OPEN_FORM_STATUS_HISTORY_DIALOG,
} from '@/types/form.types';
import { FORM_STATUS_HISTORY, GET_FORM_STATUS_HISTORY_LIST, MANAGER_LOADING } from '@/types/managerForm.types';
import { Form101DataModel } from '@/models/form/Form101Data.model';
import { GridColumn } from '@/models/GridColumn.model';
import { Grid } from '@/models/Grid.model';

@Component({})
export default class FormStatusHistoryModal extends Vue {

  @Action(GET_FORM_STATUS_HISTORY_LIST, StoreNamespace.MANAGER) public getFormStatusHistoryList;

  @Mutation(SET_OPEN_FORM_STATUS_HISTORY_DIALOG, StoreNamespace.FORM) public setOpenFormStatusHistoryDialog;

  @Getter(OPEN_FORM_STATUS_HISTORY_DIALOG, StoreNamespace.FORM) public openFormStatusHistoryDialog!: boolean;
  @Getter(FORM101_DATA, StoreNamespace.FORM) public form101Data!: Form101DataModel;
  @Getter(FORM_STATUS_HISTORY, StoreNamespace.MANAGER) public formStatusHistory!: Grid;
  @Getter(MANAGER_LOADING, StoreNamespace.MANAGER) public managerLoading!: boolean;


  private columns: GridColumn[] = [];

  public closeDialog(): void {
    this.setOpenFormStatusHistoryDialog(false);
  }

  public mounted(): void {
    this.initColumns();
  }

  public initColumns() {
    this.columns.push({
      property: 'statusDate', header: 'form101.wizard.formStatusHistory.statusDate', hideSorting: true,
      isDateTime: true,
    } as GridColumn);
    this.columns.push({
      property: 'actionDesc', header: 'form101.wizard.formStatusHistory.actionDesc', hideSorting: true,
    } as GridColumn);
    this.columns.push({
      property: 'updateUserFullName',
      header: 'form101.wizard.formStatusHistory.updateUserFullName',
      hideSorting: true,
    } as GridColumn);
  }

  public destroyed() {
    this.setOpenFormStatusHistoryDialog(false);
  }

}
